import AppointmentBookingContainer from './AppointmentBookingContainer';

export default AppointmentBookingContainer;